import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fastDeepEqual from 'fast-deep-equal';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { ModuleId } from '@intellio/shared/models';

import * as ModuleConfigsActions from './module-configs.actions';
import * as ModuleConfigsSelectors from './module-configs.selectors';

@Injectable()
export class ModuleConfigsFacade {
  moduleConfigs$ = (moduleId: ModuleId) =>
    this.store.pipe(
      select(ModuleConfigsSelectors.getConfigs(moduleId)),
      filter((configs) => configs != null),
      distinctUntilChanged(fastDeepEqual)
    );

  moduleConfigsLoaded$ = (moduleId: ModuleId) =>
    this.store.pipe(
      select(ModuleConfigsSelectors.getConfigsLoaded(moduleId)),
      distinctUntilChanged()
    );

  moduleConfigsLoading$ = (moduleId: ModuleId) =>
    this.store.pipe(
      select(ModuleConfigsSelectors.getConfigsLoading(moduleId)),
      distinctUntilChanged()
    );

  constructor(private store: Store) {}

  dispatchGetModuleConfigs(moduleId: ModuleId, override = false) {
    combineLatest([
      this.store.pipe(
        select(ModuleConfigsSelectors.getConfigsLoaded(moduleId))
      ),
      this.store.pipe(
        select(ModuleConfigsSelectors.getConfigsLoading(moduleId))
      ),
    ])
      .pipe(take(1))
      .subscribe(([loaded, loading]) => {
        if ((loaded === true && !override) || loading === true) {
          return;
        }
        this.store.dispatch(
          ModuleConfigsActions.getModuleConfigs({ moduleId })
        );
      });
  }
}
